const IncomeTourism = () => import('@/views/tourist/spending/IncomeTourism') //23
const RevenueRegion = () => import('@/views/tourist/spending/RevenueRegion') //24
const ProportionIncome = () => import('@/views/tourist/spending/ProportionIncome') //25 
const TableGdp = () => import('@/views/tourist/gdp/TableGdp') //26
const AverageIncome = () => import('@/views/tourist/spending/AverageIncome') //27
const LengthStay = () => import('@/views/tourist/length_stay/LengthStay')//40
const IncomeVisiting = () => import('@/views/tourist/spending/IncomeVisiting')//48


const mainWidget = [
  {
    title: 'รายได้จากการท่องเที่ยวในแต่ละพื้นที่',
    path: "/admin/widget/:category/:widget_code(23)",
    component: IncomeTourism,
  },
  {
    title: 'สัดส่วนรายได้ตามภาค',
    path: '/admin/widget/:category/:widget_code(24)',
    component: RevenueRegion,
  },
  {
    title: 'สัดส่วนรายได้ตามเมืองหลัก เมืองรอง',
    path: '/admin/widget/:category/:widget_code(25)',
    component: ProportionIncome,
  },
  {
    title: 'อัตราส่วนระหว่างรายได้กับ GDP จากการท่องเที่ยว',
    path: '/admin/widget/:category/:widget_code(26)',
    component: TableGdp,
  },
  {
    title: 'สถิติรายได้จากการท่องเที่ยวเฉลี่ยต่อหัว',
    path: '/admin/widget/:category/:widget_code(27)',
    component: AverageIncome,
  },
  {
    title: 'สัดส่วนช่องทางการติดต่อทั้งหมด',
    path: '/admin/widget/:category/:widget_code(40)',
    component: LengthStay,
  },
  {
    title: 'รายได้จากผู้เยี่ยมเยือน',
    path: '/admin/widget/:category/:widget_code(48)',
    component: IncomeVisiting,
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})